import {REACT_APP_API_HOST} from "./config";

export const API_ENDPOINT = {
	root: `${REACT_APP_API_HOST}/`,
	geolocation: `${REACT_APP_API_HOST}/general/geolocation?installation={0}`,
	fileDownload: `${REACT_APP_API_HOST}/files`,
	registerPayment: `${REACT_APP_API_HOST}/payments/{0}/register?installation={4}&returnUrl={1}&externalId={2}&plates={3}`,
	permitInvoice: `${REACT_APP_API_HOST}/permits/{0}/invoice/{1}?asPdf=true&installation={2}`,
	reservationSignal: `${REACT_APP_API_HOST}/reservations/{0}/signal?asPdf=true&installation={1}`,
	reservationQuote: `${REACT_APP_API_HOST}/reservations/{0}/quote?asPdf=true&installation={1}`,
	reservationInvoice: `${REACT_APP_API_HOST}/reservations/{0}/invoice?asPdf=true&installation={1}`,
	errorLogging: `${REACT_APP_API_HOST}/logging/ui`
}
